/**
 * @fileoverview POST handler for the "/custom_objects/:type_name/schema/fields" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameSchemaFieldsCacheKeys } from "./constants";
import type {
  PostCustomObjectsTypeNameSchemaFieldsProps,
  PostCustomObjectsTypeNameSchemaFieldsResult,
} from "./types";

export const postCustomObjectsTypeNameSchemaFields = reactQueryMutationAdapter(
  customObjectsTypeNameSchemaFieldsCacheKeys,
  ({
    appGroupId,
    typeName,
    name,
    data_type,
    display_label,
    required,
  }: PostCustomObjectsTypeNameSchemaFieldsProps): Promise<PostCustomObjectsTypeNameSchemaFieldsResult> => {
    return fetch<PostCustomObjectsTypeNameSchemaFieldsResult>(
      `/custom_objects/${encodeURIComponent(typeName)}/schema/fields`,
      "POST",
      {
        app_group_id: appGroupId,
        name,
        data_type,
        display_label,
        required,
      },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
